import { useIntl } from 'react-intl';

import { AutomationClauseType } from '~/enums/AutomationClauseTypes';
import { AutomationStatusType } from '~/enums/AutomationStatusType';

export const useGetClauseStatusOption = () => {
  const intl = useIntl();
  return [
    {
      label: intl.formatMessage({
        id: 'AutomationHooks.activeStatus',
        defaultMessage: 'Active',
        description: 'Label for active clause status option',
      }),
      value: AutomationStatusType.ACTIVE,
    },
    {
      label: intl.formatMessage({
        id: 'AutomationHooks.suspendedStatus',
        defaultMessage: 'Suspended',
        description: 'Label for suspended clause status option',
      }),
      value: AutomationStatusType.SUSPENDED,
    },
  ];
};

export const useGetClauseTypeOption = () => {
  const intl = useIntl();
  return [
    {
      label: intl.formatMessage({
        id: 'AutomationHooks.quickAiType',
        defaultMessage: 'Quick AI',
        description: 'Label for Quick AI clause type option',
      }),
      value: AutomationClauseType.QUICK_AI,
    },
    {
      label: intl.formatMessage({
        id: 'AutomationHooks.guidedAiType',
        defaultMessage: 'Guided AI',
        description: 'Label for Guided AI clause type option',
      }),
      value: AutomationClauseType.GUIDED_AI,
    },
  ];
};
